import React from 'react';
import { composer } from '../../component-decorators/composer';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import s from './empty-state.scss';
import { Divider, Text } from '@wix/design-system';

export const EmptyStateDivider = composer()
  .withTranslation()
  .compose(({ t }: Partial<WithTranslationProps>) => (
    <div className={s.emptyStateDivider}>
      <div className={s.dividerWrapper}>
        <Divider />
      </div>
      <Text className={s.emptyStateText} secondary={true}>
        {t('manage-apps.empty-state.divider')}
      </Text>
      <div className={s.dividerWrapper}>
        <Divider />
      </div>
    </div>
  ));
